import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderThemeOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderThemeOpen",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.61 10.67h-7.32c-.21 0-.39-.13-.46-.33l-1.05-3.16a3.41 3.41 0 0 0-3.21-2.32h-3.02c-1.44 0-2.73.91-3.21 2.27L7.2 10.59l-.49-.33c-.52-.44-1.17-.68-1.85-.68-1.57 0-2.86 1.26-2.87 2.83 0 .82.34 1.6.95 2.14.21.17.44.32.68.44l1.05.68c-.62.33-.92 1.06-.7 1.73l2.87 8.73c.2.59.75.99 1.37.99H26.6c1.87 0 3.39-1.52 3.39-3.39v-9.7c0-1.87-1.52-3.38-3.39-3.38ZM4.09 14.13c-.17-.08-.32-.18-.46-.31a1.86 1.86 0 0 1-.31-2.61 1.86 1.86 0 0 1 2.79-.15l10.51 6.91-1.99 3.06-10.55-6.9Zm12.7 7.78c-.2.3-.6.39-.91.19a.63.63 0 0 1-.29-.42c-.03-.17 0-.35.1-.5l1.42-2.19c.1-.15.25-.26.43-.29.36-.07.7.15.78.51.03.17 0 .35-.1.5l-1.43 2.19Zm6.57 3.19h-.05c-.29.03-.58.05-.86.05h-.06c-.62.02-1.24-.03-1.85-.13h-.05c-.34-.05-.68-.14-1-.25-1.98-.66-2.14-2.59-.86-3.93s3.15-.45 3.78 1.56c.12.43.34.83.66 1.16.1.11.22.2.35.26.24.07.41.26.47.5.06.35-.16.69-.51.77v.02Zm2.77-.86h-.11a.99.99 0 0 1-.79-.68l-.78-2.34-1.9-5.7h-7.91l-2.92-1.93h11.47c.41 0 .78.26.92.66l.45 1.34 1.17 3.53 1.31 3.84c.04.1.05.2.05.3 0 .53-.43.97-.97.97h-.04l.03.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19.06 29.29h-3.2c-1.89 0-3.43-1.54-3.43-3.43V13.29c0-1.89 1.54-3.43 3.43-3.43h3.2c1.89 0 3.43 1.54 3.43 3.43v12.57c0 1.89-1.54 3.43-3.43 3.43m-3.2-17.15c-.63 0-1.14.51-1.14 1.14v12.57c0 .63.51 1.14 1.14 1.14h3.2c.63 0 1.14-.51 1.14-1.14V13.28c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.16 29.28H17A1.14 1.14 0 1 1 17 27h12.16c.23 0 .42-.19.42-.42v-3.01a1.14 1.14 0 1 1 2.28 0v3.01c0 1.49-1.21 2.7-2.7 2.7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.38 26.97c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l8.09-8.09c.11-.11.12-.23.12-.29s-.02-.19-.12-.29l-3.29-3.29a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.29 3.29c.51.51.79 1.19.79 1.91s-.28 1.4-.79 1.91l-8.09 8.09c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 11c-.63 0-1.14-.51-1.14-1.14V7.57c0-.63-.51-1.14-1.14-1.14h-7.05c-.9 0-1.79-.37-2.42-1l-.95-.95c-.22-.22-.5-.33-.81-.33h-6.27c-.63 0-1.14.51-1.14 1.14v4.57a1.14 1.14 0 1 1-2.28 0V5.29c0-1.89 1.54-3.43 3.43-3.43h6.27c.92 0 1.78.36 2.42 1l.95.95c.21.21.51.33.81.33h7.05c1.89 0 3.43 1.54 3.43 3.43v2.29c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9 29.28H6.96c-1.55 0-2.91-1.04-3.31-2.54L-.02 13.03c-.28-1.04-.06-2.12.59-2.97a3.41 3.41 0 0 1 2.72-1.34h6.86a1.14 1.14 0 1 1 0 2.28H3.29c-.36 0-.69.16-.91.45-.22.28-.29.64-.2.99l3.67 13.71c.13.5.59.85 1.1.85h2.04a1.14 1.14 0 1 1 0 2.28Z"
      })]
    })
  }));
};